module.exports = __webpack_public_path__ + "static/img/info_button2_inactive.cd6ebb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/info_button2_inactive.png
// module id = Vwc2
// module chunks = 4